"use client";

import type { RouteGeoData } from "@trydig/centra/middleware";
import { createContext, type PropsWithChildren, use } from "react";
import type { GlobalData } from "./dal";

interface GlobalDataContext {
	userdata: RouteGeoData | null;
	data: GlobalData;
}

export const GlobalContext = createContext<GlobalDataContext>(null!);

export const GlobalProvider = ({
	children,
	data,
	userdata,
}: PropsWithChildren<{
	data: GlobalDataContext["data"];
	userdata: GlobalDataContext["userdata"];
}>) => {
	return (
		<GlobalContext.Provider
			value={{
				data,
				userdata,
			}}
		>
			{children}
		</GlobalContext.Provider>
	);
};

export const useGlobal = () => {
	const ctx = use(GlobalContext);
	if (!ctx) {
		throw new Error("useGlobal must be used within a GlobalProvider");
	}
	return ctx;
};
